export default __webpack_public_path__ + "static/media/Sample.4be7ae65.xlsx";